"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveBusinessId = RemoveBusinessId;
exports.getToken = getToken;
exports.getUserInfo = void 0;
exports.removeLegacyAuth = removeLegacyAuth;
exports.removeToken = removeToken;
exports.removeToken1 = removeToken1;
exports.removeUserInfo = void 0;
exports.setBusinessId = setBusinessId;
exports.setToken = setToken;
exports.setUserInfo = void 0;
require("core-js/modules/web.dom.iterable");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
// const TokenKey = "satoken"
var TokenKey = 'Token';
var TokenKey1 = 'token';
var IDKey = "businessId";
var LEGACY_COOKIE_OPTIONS = {
  domain: '.icve.com.cn',
  path: '/'
};
function getToken() {
  return _jsCookie.default.get(TokenKey);
}
function setToken(token) {
  return _jsCookie.default.set(TokenKey, token);
}
function removeToken1() {
  return _jsCookie.default.remove(TokenKey1);
}
function removeToken() {
  return _jsCookie.default.remove(TokenKey);
}
function removeLegacyAuth() {
  ;
  ['auth', 'displayName', 'icveUserType', TokenKey1].forEach(function (key) {
    _jsCookie.default.remove(key);
    _jsCookie.default.remove(key, LEGACY_COOKIE_OPTIONS);
  });
  localStorage.removeItem('idToken');
}
function setBusinessId(id) {
  return _jsCookie.default.set(IDKey, id);
}
function RemoveBusinessId(id) {
  return _jsCookie.default.remove(IDKey);
}

// localStorage key
var USER_INFO_KEY = 'user_info';
var getUserInfo = exports.getUserInfo = function getUserInfo() {
  if (!getToken()) {
    return '';
  }
  var userInfo = localStorage.getItem(USER_INFO_KEY) || '';
  return userInfo ? JSON.parse(userInfo) : '';
};
var setUserInfo = exports.setUserInfo = function setUserInfo(userInfo) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
};
var removeUserInfo = exports.removeUserInfo = function removeUserInfo() {
  localStorage.removeItem(USER_INFO_KEY);
};